import { ConfirmationData } from "../../../../common/summary-common/confirmationData";

export const overWritePersonalInformationOfTheInsured: Map<string, ConfirmationData> = new Map([
    ["fb2dd4bb-24bb-4700-89bb-a53f014ef25b", { hidden: true }],
    ["1c5e3d28-481e-4d64-be0c-07529a1ef7e3|32c72e92-0aa6-4582-a1fa-737c243ed69f", { fontWeight: "bold", showBorder: true }],
    ["1c5e3d28-481e-4d64-be0c-07529a1ef7e3|773e8c82-3c69-4745-8520-43ac32b1b030", { fontWeight: "bold", showBorder: true }],
    ["1c5e3d28-481e-4d64-be0c-07529a1ef7e3|84f4b5e2-a240-4405-839b-a35924df2fa8", { fontWeight: "bold", showBorder: true }],
    ["1c5e3d28-481e-4d64-be0c-07529a1ef7e3|a1c1f62e-326b-46f0-bb7d-33d436ca267d", { fontWeight: "bold", showBorder: true }],
    ["1c5e3d28-481e-4d64-be0c-07529a1ef7e3|103a15f4-0d02-496a-bf0f-994ee9e4b945", { fontWeight: "bold", showBorder: true }],

    ["af470f19-999f-48a9-8905-bc8c007cc074", { hiddenAll: true }],
    
]);



